export default __webpack_public_path__ + "static/RunLeft8-aa9a797d1571d86d2ae91877e21bae3a.mp3";